export const requestBaseUrl = process.env.REACT_APP_SERVICE_BASE_URL
export const accessTokenKey = `${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}_${process.env.REACT_APP_ACCESS_TOKEN_KEY}`
export const timezoneKey = `${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}_TZ`
export const remittanceKey = `${process.env.REACT_APP_LOCAL_STORAGE_PREFIX}_RMT`

export const NO_RESPONSE_ERROR = 'No Response'
export const CONFIG_ERROR = 'Config Error'
